<template>
	<c-dialog ref="dialog" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="部门编号" required>
				<c-input name="department_code"></c-input>
			</c-form-item>
			<c-form-item label="部门名称" required>
				<c-input name="department_name"></c-input>
			</c-form-item>
			<c-form-item label="用户">
				<c-select name="user_list" async :multiple="{limit:200,linefeed:true}" @search="searchUser" :value-data="selectedUser"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				selectedUser:[]
			}
		},

		methods: {
			/************打开新增、编辑弹窗，数据初始化**************/
			open(data) {
				this._editState = !!data;
				this.$refs.form.clear();
				if (data) {
					this.$refs.form.set(data);
					//查询部门详情
					this.request({
						url:'/department/detail',
						data: {
							id:data.id
						},
						success:data => {
							//已选中的用户
							this.selectedUser = data.userList.map(item => {
								return {
									name:item.user_realname,
									value:item.id
								}
							});
						}
					})
				}
				//填充form表单
				this.$refs.dialog.open({
					title: data ? '编辑部门' : '创建部门'
				});
			},

			/************搜索用户*******************************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/************创建、编辑提交处理方法*******************************/
			editHandle (stop, next){
				stop();
				this.$refs.form.submit({
					url: this._editState?'/department/edit':'/department/add',
					rule: {
						department_code: '请输入部门编号',
						department_name: '请输入部门名称'
					},
					success: (data, res) => {
						next();
						this.$message({
							message: '提交成功',  // 提示内容,
							type: 'success'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>